import { useEffect } from 'react';

import { Card, CardContent, CardHeader, CardTitle } from '~shared/shadcn/ui/card';

export function buildParentPortalShareRedirectUrl(input: {
  path: 'public-class-share' | 'public-event-share';
  shareToken: string;
  studioId?: string;
}): string {
  const rawBase = import.meta.env.VITE_PARENT_PORTAL_URL;
  const base =
    typeof rawBase === 'string' && rawBase.trim().length > 0
      ? rawBase.replace(/\/$/, '')
      : '';
  const shareToken =
    typeof input.shareToken === 'string' ? input.shareToken.trim() : '';
  if (!base || shareToken.length === 0) {
    return '';
  }

  try {
    const url = new URL(
      `${base}/${input.path}/${encodeURIComponent(shareToken)}`,
    );
    const studioId =
      typeof input.studioId === 'string' ? input.studioId.trim() : '';
    if (studioId.length > 0) {
      url.searchParams.set('studioId', studioId);
    }
    return url.toString();
  } catch {
    return '';
  }
}

interface RedirectToParentPortalShareProps {
  path: 'public-class-share' | 'public-event-share';
  shareToken: string;
  studioId?: string;
}

export function RedirectToParentPortalShare({
  path,
  shareToken,
  studioId,
}: RedirectToParentPortalShareProps) {
  const targetUrl = buildParentPortalShareRedirectUrl({
    path,
    shareToken,
    studioId,
  });

  useEffect(() => {
    if (targetUrl.length > 0) {
      window.location.replace(targetUrl);
    }
  }, [targetUrl]);

  if (targetUrl.length === 0) {
    return (
      <div className='flex min-h-screen items-center justify-center p-4'>
        <Card className='w-full max-w-md'>
          <CardHeader>
            <CardTitle>Public link unavailable</CardTitle>
          </CardHeader>
          <CardContent className='text-sm text-muted-foreground'>
            Parent portal URL is not configured. Set VITE_PARENT_PORTAL_URL to
            the parent portal (enrollio-fe), then open the share link from the
            studio event or class page again.
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className='flex min-h-screen items-center justify-center p-4 text-muted-foreground'>
      Opening public page…
    </div>
  );
}
